import $ from 'jquery';
import Slider from '@/shared/slider';

$(() => {
    /**
     * slick
     */
    const slider = new Slider();
    slider.apply();
});
